// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@property --shimmer-transparency {
  syntax: '<percentage>';
  /* <- defined as type number for the transition to work */
  initial-value: 20%;
  inherits: false;
}
.rsRoWv8EKwTTXn {
  width: 100%;
  height: 56px;
  margin-bottom: var(--ds-space-150, 12px);
  cursor: progress;
  background-color: color-mix(in srgb, var(--board-header-background-color, var(--ds-surface-hovered, #f1f2f4)) var(--shimmer-transparency, 100%), transparent);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  animation-name: dV1cPn5QakVP1q;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
@keyframes dV1cPn5QakVP1q {
  from {
    --shimmer-transparency: 100%;
  }
  to {
    --shimmer-transparency: 50%;
  }
}
@media (prefers-reduced-motion: reduce) {
  .rsRoWv8EKwTTXn {
    animation: none;
    --shimmer-transparency: 100%;
  }
}
.R3j5kOx1iHCkCk {
  display: flex;
  flex-direction: row;
  padding: var(--ds-space-0, 0) 6px;
  list-style: none;
}
.iPdwlH68AyXgJo {
  flex-shrink: 0;
  width: 272px;
  margin: var(--ds-space-0, 0) 6px;
  border-radius: var(--ds-border-radius-300, 12px);
  vertical-align: top;
  cursor: progress;
  background-color: color-mix(in srgb, var(--board-header-background-color, var(--ds-surface-hovered, #f1f2f4)) var(--shimmer-transparency, 100%), transparent);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  animation-name: dV1cPn5QakVP1q;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
@keyframes dV1cPn5QakVP1q {
  from {
    --shimmer-transparency: 100%;
  }
  to {
    --shimmer-transparency: 50%;
  }
}
.iPdwlH68AyXgJo:nth-of-type(1) {
  background-color: color-mix(in srgb, var(--board-header-background-color, var(--ds-surface-hovered, #f1f2f4)) var(--shimmer-transparency, 100%), transparent);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  animation: Bg14Bc4LRUijtb 7.2s infinite normal, dV1cPn5QakVP1q 1.5s linear infinite alternate;
}
@keyframes Bg14Bc4LRUijtb {
  0% {
    animation-timing-function: linear;
    height: 306px;
  }
  6.94% {
    animation-timing-function: cubic-bezier(0.17, 0.67, 0.27, 1);
    height: 306px;
  }
  33.33% {
    animation-timing-function: linear;
    height: 44px;
  }
  40.28% {
    animation-timing-function: cubic-bezier(0.17, 0.67, 0.27, 1);
    height: 44px;
  }
  66.67% {
    animation-timing-function: linear;
    height: 162px;
  }
  73.61% {
    animation-timing-function: cubic-bezier(0.17, 0.67, 0.27, 1);
    height: 162px;
  }
  100% {
    animation-timing-function: linear;
    height: 306px;
  }
}
@keyframes dV1cPn5QakVP1q {
  from {
    --shimmer-transparency: 100%;
  }
  to {
    --shimmer-transparency: 50%;
  }
}
@media (prefers-reduced-motion: reduce) {
  .iPdwlH68AyXgJo:nth-of-type(1) {
    animation: none;
    --shimmer-transparency: 100%;
  }
}
.iPdwlH68AyXgJo:nth-of-type(2) {
  background-color: color-mix(in srgb, var(--board-header-background-color, var(--ds-surface-hovered, #f1f2f4)) var(--shimmer-transparency, 100%), transparent);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  animation: BEz3hSHALigs9q 7.2s infinite normal, dV1cPn5QakVP1q 1.5s linear infinite alternate;
}
@keyframes BEz3hSHALigs9q {
  0% {
    animation-timing-function: linear;
    height: 162px;
  }
  6.94% {
    animation-timing-function: cubic-bezier(0.17, 0.67, 0.27, 1);
    height: 162px;
  }
  33.33% {
    animation-timing-function: linear;
    height: 306px;
  }
  40.28% {
    animation-timing-function: cubic-bezier(0.17, 0.67, 0.27, 1);
    height: 306px;
  }
  66.67% {
    animation-timing-function: linear;
    height: 44px;
  }
  73.61% {
    animation-timing-function: cubic-bezier(0.17, 0.67, 0.27, 1);
    height: 44px;
  }
  100% {
    animation-timing-function: linear;
    height: 162px;
  }
}
@keyframes dV1cPn5QakVP1q {
  from {
    --shimmer-transparency: 100%;
  }
  to {
    --shimmer-transparency: 50%;
  }
}
@media (prefers-reduced-motion: reduce) {
  .iPdwlH68AyXgJo:nth-of-type(2) {
    animation: none;
    --shimmer-transparency: 100%;
  }
}
.iPdwlH68AyXgJo:nth-of-type(3) {
  background-color: color-mix(in srgb, var(--board-header-background-color, var(--ds-surface-hovered, #f1f2f4)) var(--shimmer-transparency, 100%), transparent);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  animation: QVQjv3hoT91OZb 7.2s infinite normal, dV1cPn5QakVP1q 1.5s linear infinite alternate;
}
@keyframes QVQjv3hoT91OZb {
  0% {
    animation-timing-function: linear;
    height: 44px;
  }
  6.94% {
    animation-timing-function: cubic-bezier(0.17, 0.67, 0.27, 1);
    height: 44px;
  }
  33.33% {
    animation-timing-function: linear;
    height: 162px;
  }
  40.28% {
    animation-timing-function: cubic-bezier(0.17, 0.67, 0.27, 1);
    height: 162px;
  }
  66.67% {
    animation-timing-function: linear;
    height: 306px;
  }
  73.61% {
    animation-timing-function: cubic-bezier(0.17, 0.67, 0.27, 1);
    height: 306px;
  }
  100% {
    animation-timing-function: linear;
    height: 44px;
  }
}
@keyframes dV1cPn5QakVP1q {
  from {
    --shimmer-transparency: 100%;
  }
  to {
    --shimmer-transparency: 50%;
  }
}
@media (prefers-reduced-motion: reduce) {
  .iPdwlH68AyXgJo:nth-of-type(3) {
    animation: none;
    --shimmer-transparency: 100%;
  }
}
`, ""]);
// Exports
export var boardHeaderSkeleton = `rsRoWv8EKwTTXn`;
export var shimmer = `dV1cPn5QakVP1q`;
export var lists = `R3j5kOx1iHCkCk`;
export var listSkeleton = `iPdwlH68AyXgJo`;
export var listSkeletonAnimation1 = `Bg14Bc4LRUijtb`;
export var listSkeletonAnimation2 = `BEz3hSHALigs9q`;
export var listSkeletonAnimation3 = `QVQjv3hoT91OZb`;
export default ___CSS_LOADER_EXPORT___;
